/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useEmptyStringFormat } from '@/hooks/fn';
import useMortarSaleRank from './hooks/useMortarSaleRank';
import useMortarSaleTrend from './hooks/useMortarSaleTrend';
import { BarEchartMul } from '@/components/page-echarts';
import CTypeTab from '@/components/CTypeTab.vue';
import localCache from '@/utils/localCache';
export default defineComponent({
  name: 'AggregateDailySalesReport',
  components: {
    BarEchartMul: BarEchartMul,
    CTypeTab: CTypeTab
  },
  // props: {
  //   type: {
  //     type: Number,
  //     required: true
  //   }
  // },
  setup: function setup() {
    var params = ref({
      date: dayjs().format('YYYY/MM/DD'),
      type: 0 //时间类型 0日数据 1周数据 2月数据
    });
    var confrimDate = function confrimDate(val) {
      params.value.date = val;
      getAggregateSaleRankAsync();
      getProdCmSaleVlBarAsync();
      if (params.value.type === 3) {
        getProdCmSaleVlBarYearAsync();
      }
    };
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var _dateRef$value;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              if (val === 4) {
                params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
              } else {
                params.value.date = dayjs().format('YYYY/MM/DD');
              }
              if (val === 3) {
                getProdCmSaleVlBarYearAsync();
              }
              getAggregateSaleRankAsync();
              getProdCmSaleVlBarAsync();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var switchClick = function switchClick() {
      if (params.value.type === 0) {
        window.location.href = "/table/shajiangSellDay.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
      if (params.value.type === 1) {
        window.location.href = "/table/shajiangSellWeek.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
      if (params.value.type === 2) {
        window.location.href = "/table/shajiangSellMonth.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
    };
    var _useMortarSaleRank = useMortarSaleRank(params),
      _useMortarSaleRank2 = _slicedToArray(_useMortarSaleRank, 2),
      aggregateSaleRankData = _useMortarSaleRank2[0],
      getAggregateSaleRankAsync = _useMortarSaleRank2[1];
    getAggregateSaleRankAsync();
    var emptyStringFormat = useEmptyStringFormat();
    var tabs = ref(['销量', '金额']);
    var curTab = ref('销量');
    var tabClick = function tabClick(val) {
      curTab.value = val;
    };
    var _useMortarSaleTrend = useMortarSaleTrend(params),
      _useMortarSaleTrend2 = _slicedToArray(_useMortarSaleTrend, 4),
      aggregateSaleTrendData = _useMortarSaleTrend2[0],
      aggregateSaleTrendYearData = _useMortarSaleTrend2[1],
      getProdCmSaleVlBarAsync = _useMortarSaleTrend2[2],
      getProdCmSaleVlBarYearAsync = _useMortarSaleTrend2[3];
    console.log(aggregateSaleTrendYearData);
    getProdCmSaleVlBarAsync();
    var dayData = computed(function () {
      var prod = aggregateSaleTrendData.value.prod;
      var sale = aggregateSaleTrendData.value.sale;
      // const stock = aggregateSaleTrendData.value.stock;
      var xLabels = aggregateSaleTrendData.value.xAxis;
      var legendData = ['产量', '销量'];
      return {
        xLabels: xLabels,
        lineData: [prod, sale],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324'],
        grid: {
          left: 55,
          top: 10,
          bottom: 55,
          right: 35
        },
        legendBottom: 2,
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                    <div >\n                      <div class=\"flex align-center\">\n                        <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                      </div>\n                    ");
          params1.forEach(function (item) {
            res += "\n                      <div >\n                        ".concat(item.marker, "\n                        <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                        <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value, "\u5428 </span>\n                      </div>\n                    ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var stockData = computed(function () {
      var stock = aggregateSaleTrendData.value.stock;
      var xLabels = aggregateSaleTrendData.value.xAxis;
      var legendData = ['库存'];
      return {
        xLabels: xLabels,
        lineData: [stock],
        legendData: legendData,
        colors: ['#EEC324', '#5AC57F', '#EEC324'],
        grid: {
          left: 55,
          top: 10,
          bottom: 55,
          right: 35
        },
        legendBottom: 2,
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                    <div >\n                      <div class=\"flex align-center\">\n                        <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                      </div>\n                    ");
          params1.forEach(function (item) {
            res += "\n                      <div >\n                        ".concat(item.marker, "\n                        <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                        <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value, "\u5428 </span>\n                      </div>\n                    ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var router = useRouter();
    var toReportDetail = function toReportDetail() {
      router.push({
        name: 'SaleReportDetail',
        params: {
          date: params.value.date,
          type: params.value.type,
          reportType: 'mortar' //砂浆商砼砂浆
        }
      });
    };
    return {
      params: params,
      confirmType: confirmType,
      confrimDate: confrimDate,
      switchClick: switchClick,
      emptyStringFormat: emptyStringFormat,
      tabs: tabs,
      curTab: curTab,
      tabClick: tabClick,
      aggregateSaleRankData: aggregateSaleRankData,
      dayData: dayData,
      stockData: stockData,
      toReportDetail: toReportDetail,
      dateRef: dateRef
    };
  }
});